import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_EVENTS_EVENT_CALENDAR_PAGE: IInventoryPage = {
	'route': '/research/events/event-calendar',
	'title': 'Calendar',
	'uiReference': [
		'Open in Amazon',
		'Open in Spreadshirt',
		'Event Calendar',
		'Discover seasonal opportunities, public holidays, and social moments for your marketplace.',
		'Setup Reminders',
		'Marketplace calendar',
		'Choose a country to load its regional holidays.',
		'Select an event to explore related keywords, marketplaces, and bestselling designs.',
		'Ongoing this month',
		'Long-running observances',
		'Selected event',
		'Validate the opportunity across marketplaces, then explore related keywords and designs.',
		'Explore on',
		'Amazon',
		'Spreadshirt',
		'Research signals',
		'Related Keywords',
		'Choose a keyword to load matching designs.',
		'Marketplace results',
		'Designs',
		'Select a design to inspect its complete research details.',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Remove from favorites',
		'Enter a tag',
		'Favorite tag',
		'Generate image using AI',
		'NEW',
		'History Rank :',
		'History Price : NA',
		'Removed',
		'ASIN',
		'review(s)',
		'Published since',
		'Saved',
		'Update tag'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/events/events-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/events/event-calendar/event-calendar.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/events/event-calendar/event-calendar.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/events/event-calendar/event-calendar.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.html'
	],
	'aliases': []
};
